module.exports = __webpack_public_path__ + "static/media/home.4d0f929f.svg";